import React, {Component} from 'react';
import '../styles/LoadingPlaceholder.css';
import BrandUtils from '../utils/BrandUtils';
import CommonUtils from '../utils/CommonUtils';
import Constants from '../utils/Constants';

class LoadingPlaceholder extends Component {
  render() {
    let brandName = BrandUtils.getCachedBrandName()
    if(CommonUtils.isEmpty(brandName)) {
      brandName = Constants.Strings.APP_NAME
    }

    return (
      <div className="loading-placeholder masked">
        <div className="title">{brandName}</div>
        <div className="slogan">{Constants.Strings.SLOGAN}</div>
      </div>
    );
  }
}

export default LoadingPlaceholder;


// WEBPACK FOOTER //
// ./src/components/LoadingPlaceholder.js